import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "card mb-5",
  ref: "root"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Retention")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger d-flex justify-content-between align-items-center mb-0"
}
const _hoisted_5 = {
  key: 1,
  class: "placeholder-glow"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "placeholder col-12",
  style: {"height":"200px"}
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_9 = {
  key: 3,
  class: "table-responsive"
}
const _hoisted_10 = { class: "table table-row-dashed align-middle" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bold text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Cohort"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Size"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "D1"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "D7"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "D30")
  ])
], -1)
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.error), 1),
            _createElementVNode("button", {
              class: "btn btn-sm btn-outline-danger",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry')))
            }, " Retry ")
          ]))
        : (!_ctx.loaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : ((_ctx.retention.cohorts ?? []).length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " No cohort data for this range. Run the activity backfill, or pick a range that contains registrations. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("table", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.retention.cohorts, (c) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: c.cohortDate
                      }, [
                        _createElementVNode("td", null, _toDisplayString(c.cohortDate.slice(0, 10)), 1),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(c.cohortSize), 1),
                        _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.formatRate(c.d1Rate)), 1),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.formatRate(c.d7Rate)), 1),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.formatRate(c.d30Rate)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
    ])
  ], 512))
}